import { render, staticRenderFns } from "./DFElement.vue?vue&type=template&id=3ccc6d42&"
import script from "./DFElement.vue?vue&type=script&lang=js&"
export * from "./DFElement.vue?vue&type=script&lang=js&"
import style0 from "./DFElement.vue?vue&type=style&index=0&id=3ccc6d42&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports